import React, { useEffect, useState } from "react";
import CustomDataGrid from "../custom/CustomDataGrid";
import axios from "axios";

export default function InstitutionalData() {
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_HOST}/institutions`, {})
      .then((response) => {
        setRows(
          response.data.data.map((institution, index) => ({
            id: index + 1 + (page - 1) * 10,
            code: institution.code,
            name: institution.name,
            city: institution.city,
          }))
        );
      })
      .catch((error) => {
        console.error("Error fetching institutions", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <CustomDataGrid
        rows={rows}
        loading={loading}
        columns={[
          { field: "id", headerName: "No.", flex: 1 },
          { field: "code", headerName: "Kode Universitas", flex: 1 },
          { field: "name", headerName: "Nama Universitas", flex: 1 },
          { field: "city", headerName: "Kota Universitas", flex: 1 },
        ]}
        setPage={setPage}
      />
    </div>
  );
}
